// import React, { useEffect, useState } from "react";

export const USER_KEY = "USER_KEY";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const AUTH_KEY = process.env.auth || "DEFAULT_AUTH_KEY";

// export const setToken = (data) => {
//   if (typeof window !== "undefined") {
//     localStorage.setItem(AUTH_KEY, JSON.stringify(data));
//   }
// };

export const setToken = (data) => {
  if (typeof window !== "undefined") {
    if (data) {
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(data));
      } catch (error) {
        console.error("Error saving user data to localStorage:", error);
      }
    } else {
      console.warn("No data provided to setToken");
    }
  }
};

export const clearToken = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(ACCESS_TOKEN);
  }
};

// export const getUserLocalStorage = () => {
//   if (typeof window !== "undefined") {
//     const token = localStorage.getItem(USER_KEY);
//     return token ? JSON.parse(token) : null;
//   }
//   return null;
// };

export const getToken = () => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem(ACCESS_TOKEN);

    return token ? token : null;
  }
  return null;
};

// export default function auth() {
//   if (typeof window !== "undefined") {
//     const userData = localStorage.getItem(USER_KEY);
//     return userData ? JSON.parse(userData) : false;
//   }
//   return false;
// }

export const getUserLocalStorage = () => {
  if (typeof window !== "undefined") {
    const userData = localStorage.getItem(USER_KEY);
    try {
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  }
  return null;
};

// export const auth = () => {
//   if (typeof window !== "undefined") {
//     const userData = localStorage.getItem(USER_KEY);
//     try {
//       return userData ? JSON.parse(userData) : false;
//     } catch (error) {
//       console.error("Error parsing user data from localStorage:", error);
//       return false;
//     }
//   }
//   return false;
// };

export const auth = () => {
  if (typeof window !== "undefined") {
    const userData = localStorage.getItem(USER_KEY);
    if (!userData) {
      return false;
    }
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      localStorage.removeItem(USER_KEY);
      return false;
    }
  }
  return false;
};

export const checkProfile = () => {
  if (typeof window !== "undefined") {
    const userData = localStorage.getItem(USER_KEY);
    const accessToken = localStorage.getItem(ACCESS_TOKEN);

    // Trả về true nếu cả userData và accessToken đều tồn tại và hợp lệ
    if (userData && accessToken) {
      try {
        JSON.parse(userData); // Kiểm tra JSON có hợp lệ không
        return true;
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
        localStorage.removeItem(USER_KEY); // Xóa nếu lỗi
        return false;
      }
    }
  }
  return false;
};

// export const getToken = () => {
//   if (typeof window !== "undefined") {
//     const token = localStorage.getItem(ACCESS_TOKEN);
//     if (token) {
//       try {
//         return JSON.parse(token);
//       } catch (e) {
//         console.error("Error parsing ACCESS_TOKEN from localStorage:", e);
//         return null;
//       }
//     }
//   }
//   return null;
// };

// export const getUserLocalStorage = () => {
//   if (typeof window !== "undefined") {
//     const token = localStorage.getItem(USER_KEY);
//     if (token) {
//       try {
//         return JSON.parse(token);
//       } catch (e) {
//         console.error("Error parsing USER_KEY from localStorage:", e);
//         return null;
//       }
//     }
//   }
//   return null;
// };
